var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chat-product-card" }, [
    _c("div", { staticClass: "product-type-pill" }, [
      _vm._v("\n\t\t" + _vm._s(_vm.productType) + "\n\t")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "product-content" }, [
      _c("div", { staticClass: "product-image" }, [
        _vm.productImage
          ? _c("img", {
              attrs: { src: _vm.productImage, alt: _vm.productTitle }
            })
          : _c(
              "div",
              { staticClass: "product-placeholder" },
              [
                _c("InlineSvg", {
                  attrs: { src: "/images/icons/ic-product.svg" }
                })
              ],
              1
            )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "product-details" }, [
        _c("div", { staticClass: "product-title" }, [
          _vm._v(_vm._s(_vm.productTitle))
        ]),
        _vm._v(" "),
        _vm.productSubtitle
          ? _c("div", { staticClass: "product-subtitle" }, [
              _vm._v(_vm._s(_vm.productSubtitle))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "product-actions" }, [
        _c(
          "button",
          { staticClass: "round-button", on: { click: _vm.viewProduct } },
          [_c("InlineSvg", { attrs: { src: "/images/icons/ic-plus.svg" } })],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }